import { Injectable } from '@angular/core';
import { DashboardFilter } from './dashboard-filter';

@Injectable()
export class HierarchyDashboardDrilldownService {

  public drillDownRoute = '/hierarchy';

  public RiskBandFilter: DashboardFilter = new DashboardFilter('RiskBand', 'Risk Band');
  public ModelNameFilter: DashboardFilter = new DashboardFilter('ModelName', 'Model Name');
  public RiskMatrixFilter: DashboardFilter = new DashboardFilter('RiskMatrix', 'Risk Matrix');
  public TemplateFilter: DashboardFilter = new DashboardFilter('Template', 'Template');

  constructor() { }
}
